import { z } from 'zod';

/**
 * Per Q1 (the unified Character/Party/User Viewer model) — a viewer is
 * the perspective the projection function filters for. At Walking Skeleton
 * scope only `'gm'` is meaningfully used; the full union is in place so
 * the substrate doesn't need to grow when players arrive in Phase 1.
 *
 * The `id` field is a stable identifier within the kind: a character id,
 * party id, user id, or "self" for gm.
 */
export const ViewerIdSchema = z
  .object({
    kind: z.enum(['gm', 'character', 'party', 'user']),
    id: z.string().min(1),
  })
  .strict();
export type ViewerId = z.infer<typeof ViewerIdSchema>;

/** Stable key used for grouping reveals + memoising projections. */
export function viewerKey(viewer: ViewerId): string {
  return `${viewer.kind}:${viewer.id}`;
}

/** True if the viewer is the GM. Used by the projection identity path. */
export function isGm(viewer: ViewerId): boolean {
  return viewer.kind === 'gm';
}
